import { FadeUp, MaskedLine, MonoLabel } from "@/components/Reveal";

const milestones = [
  {
    year: "2019",
    title: "A blog and a failed search",
    body: "I started businesscasestudies.in to write about business models I was studying. One day I asked a friend to Google a Blue Tokai case study, hoping my article would show up. It didn't. Finding out why pulled me into SEO.",
  },
  {
    year: "2020",
    title: "Merkle / Dentsu",
    body: "I joined Merkle, part of Dentsu and one of the biggest marketing agencies in the world. There I helped ecommerce and edtech brands get found on Google.",
  },
  {
    year: "2021",
    title: "Plivo",
    body: "I moved to Plivo and ran SEO for two of their brands. That same year, businesses started hiring me directly, and consulting became the main thing.",
  },
  {
    year: "Now",
    title: "Consulting, across regions",
    body: "Seven years in, I've worked with companies across APAC, the US, Europe and most recently the Middle East. First it was search engines. Now it's LLMs too, and I'm still at it.",
  },
];

export default function Journey() {
  return (
    <section id="about" className="px-6 sm:px-12 py-32 sm:py-40">
      <div className="grid grid-cols-12 gap-8 lg:gap-12">
        <div className="col-span-12 lg:col-span-4">
          <div className="lg:sticky lg:top-32">
            <FadeUp>
              <MonoLabel>About me</MonoLabel>
            </FadeUp>
            <h2 className="mt-6 font-display font-semibold text-4xl sm:text-5xl tracking-[-0.03em] leading-[1.06]">
              <MaskedLine>The journey</MaskedLine>
              <MaskedLine delay={0.1}>
                <span className="text-gradient">so far.</span>
              </MaskedLine>
            </h2>
            <FadeUp delay={0.2}>
              <p className="mt-8 text-muted-foreground text-base leading-relaxed max-w-sm">
                Seven years, four regions, one obsession: getting brands found.
              </p>
            </FadeUp>
          </div>
        </div>

        <div className="col-span-12 lg:col-span-7 lg:col-start-6 flex flex-col">
          {milestones.map((m, i) => (
            <FadeUp key={m.year} delay={i * 0.06}>
              <div
                className="grid grid-cols-12 gap-6 py-12 border-t border-black/10 first:border-t-0 first:pt-0 lg:first:pt-12"
                data-testid={`journey-milestone-${i + 1}`}
              >
                <span className="col-span-3 sm:col-span-2 font-mono text-sm sm:text-base text-primary pt-1">
                  {m.year}
                </span>
                <div className="col-span-9 sm:col-span-10">
                  <h3 className="font-display font-semibold text-2xl sm:text-3xl lg:text-4xl tracking-[-0.02em]">
                    {m.title}
                  </h3>
                  <p className="mt-5 text-base sm:text-lg text-muted-foreground leading-relaxed max-w-xl">
                    {m.body}
                  </p>
                </div>
              </div>
            </FadeUp>
          ))}
        </div>
      </div>
    </section>
  );
}
